ggAutocomplete.$inject = ["$timeout", "Profile"];angular.
module('gplans.directives').
directive('ggAutocomplete', ggAutocomplete);

ggAutocomplete.$inject = ['$timeout', 'Profile'];

function ggAutocomplete($timeout, Profile) {
  return {
    restrict: 'E',
    templateUrl: 'templates/dashboard/gg-autocomplete.directive.html',
    link: function link($scope, element, attrs) {
      $scope.foodToSearch = {};
      $scope.findedFoods = [];
      $scope.loading = false;
      $scope.mealLabels = ['breakfast', 'snack 1', 'lunch', 'snack 2', 'dinner', 'snack 3'];
      var timer = null;
      $scope.changeFoodInput = function changeFoodInput() {
        if (timer)
        $timeout.cancel(timer);
        timer = $timeout(function () {
          var obj = { q: $scope.foodToSearch.q };
          $scope.loading = true;
          var req = Profile.getFoodsForAutocomplete(obj).then(function (res) {
            $scope.loading = false;
            $scope.findedFoods = res.data;
          });
        }, 1000);
      };
    } };

}